import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

export default class WantedButton extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			isWanted: false,
			isWantedCount: 2
		}
	}

	render() {
		const {classes = '', isWanted, isWantedCount, showText = true, showIcon = true, addToWantedList, data} = this.props;
		const {item, qty, color} = data;


		return (
			<button className={classes + " btn text--no-wrap"} onClick={() => this.props.addToWantedList()}>
				{showIcon && <i className={`${isWanted ? 'text-color--primaryRed fas' : 'far'} fa-heart l-margin-right--sm`}/>}
				{showText ?
					(isWantedCount ? 
						<span>In {isWantedCount} Wanted List{isWantedCount != 1 && 's'}</span>
					:
						isWanted ? `On your Wanted List` : `Add to Wanted List`
					)
				: null}
			</button>
		);
	}
}

WantedButton.propTypes = {
	classes: PropTypes.string
};

